import { render } from "./MenuItemsManage.vue?vue&type=template&id=11703e50&scoped=true"
import script from "./MenuItemsManage.vue?vue&type=script&lang=ts"
export * from "./MenuItemsManage.vue?vue&type=script&lang=ts"

import "./MenuItemsManage.vue?vue&type=style&index=0&id=11703e50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11703e50"

export default script